import React, { Fragment } from 'react';
import {
  Edit,
  List,
  BooleanInput,
  DisabledInput,
  EditButton,
  Datagrid,
  SimpleForm,
  TextField,
  BooleanField,
  TextInput,
  CardActions,
  ListButton,
  Toolbar,
  SaveButton,
  ArrayInput,
  NumberInput,
  SelectInput,
  SimpleFormIterator,
  NumberField,
  ReferenceField,
  GET_LIST
} from 'react-admin';

import CheckBox from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';
import BulkUpdateButton from './ui/BulkUpdateButton';

import restClient from '../services/restClient';
import { appOptions } from '../config/app';

const CategoryTitle = ({ record }) => {
  return <span>Category {record ? `"${record.name}"` : ''}</span>;
};

const CategoryEditActions = ({ basePath, data, resource }) => (
  <CardActions>
      <ListButton basePath={basePath} variant="outlined" style={{marginRight: '10px', padding: '7px 16px'}} />
  </CardActions>
);

const CategoryToolbar = props => (
  <Toolbar {...props} >
      <SaveButton />
  </Toolbar>
);

const CategoryBulkActionButtons = props => (
  <Fragment>
      <BulkUpdateButton {...props} field='includeInTopNews' value={true} label='Include In Top News' icon={<CheckBox />} color='primary' />
      <BulkUpdateButton {...props} field='includeInTopNews' value={false} label="Don't Include In Top News" icon={<CheckBoxOutlineBlank />} color='secondary' />
  </Fragment>
);


export const CategoryList = props => (
  <List title="Categories" {...props} bulkActionButtons={<CategoryBulkActionButtons />} perPage={100} sort={{ field: 'order', order: 'ASC' }}>
    <Datagrid>
      <ReferenceField label="Parent" source="parentId" reference="articles/categories" allowEmpty={true}>
        <TextField source="name" />
      </ReferenceField>
      <TextField label="Name" source="name" />
      <BooleanField label="Include In Top News" source="includeInTopNews" />
      <NumberField label="Order" source="order" />
      <EditButton />
    </Datagrid>
  </List>
);

export class CategoryEdit extends React.Component {
  state = {
    categories: [],
  };

  componentDidMount() {
    const apiClient = restClient(appOptions);
    apiClient(GET_LIST, 'articles/categories').then(res => {
      const categories_list = res.data.filter(x => !x.parentId).sort((a, b) => a.order - b.order).map(x => ({'id': +x.id, 'name': x.name}));
      this.setState({ categories: categories_list });
    });
  }

  render () {
    return <Edit actions={<CategoryEditActions />} title={<CategoryTitle />} {...this.props}>
    <SimpleForm toolbar={<CategoryToolbar />}>
      <DisabledInput source="id" />
      <TextInput label="Name" source="name" />
      <SelectInput label="Parent Category" source="parentId" choices={this.state.categories} />
      <TextInput label="Link" source="link" />
      <TextInput label="Link Latest News" source="link_latest" />
      <BooleanInput label="Include In TopNews" source="includeInTopNews" />
      <BooleanInput label="Fast Decay" source="fastDecay" />
      <BooleanInput label="Pre Determined" source="preDetermined" />
      <BooleanInput label="Hide" source="hide" />
      <NumberInput label="Top News Weight" source="topNewsWeight" />
      <ArrayInput source="other_links" className="inline-form">
        <SimpleFormIterator keyName="link">
          <TextInput source="name" />
          <TextInput source="link" />
        </SimpleFormIterator>
      </ArrayInput>
      <TextInput label="Meta Title" source="meta_title" />
      <TextInput label="Meta Description" multiline source="meta_description" />
    </SimpleForm>
  </Edit>
  }
}



// WEBPACK FOOTER //
// ./src/resources/categories.js